import styled from 'styled-components';
import { colors, font, radius, shadow } from '../../styles/theme/tokens';

// Wrapper, Content, Button лишились від старої версії — експортуємо для сумісності
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Button = styled.button`
  font-family: ${font.text};
`;

export const SubmissionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  box-shadow: ${shadow.card};
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 260px;
  padding: 14px 16px;
  border-radius: ${radius.md};
  border: 1.5px solid ${colors.line};
  background: ${colors.bg};
  font-family: ${font.text};
  font-size: 16px;
  font-weight: 500;
  line-height: 1.55;
  color: ${colors.ink};
  resize: vertical;
  transition: border-color 0.15s ease, background 0.15s ease;

  &::placeholder {
    color: ${colors.muted};
  }

  &:focus {
    outline: none;
    border-color: ${colors.brand};
    background: ${colors.surface};
  }
`;

export const SubmitButton = styled.button`
  align-self: flex-end;
  min-width: 220px;
  padding: 13px 28px;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 16px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${colors.brand};
  box-shadow: ${shadow.button(colors.brandDeep)};
  cursor: pointer;
  transition: transform 0.08s ease, box-shadow 0.08s ease, opacity 0.2s;

  &:active:not(:disabled) {
    transform: translateY(3px);
    box-shadow: ${shadow.button('transparent')};
  }

  &:disabled {
    opacity: 0.55;
    cursor: default;
  }

  @media (max-width: 560px) {
    width: 100%;
  }
`;
